export const useDevice = () => {
    const isTouch = (): boolean => {
        if (typeof window === 'undefined') {
            return false
        }

        return 'ontouchstart' in document.documentElement
    }
    return { isTouch }
}
